import { useCallback, useState } from "react";
import { apiClient } from "../lib/apiClient";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

// One-time "allow notifications" prompt for Delivery-type customers — live
// "your tiffin is delivered" alerts even when the app isn't open.
export function usePushNotifications() {
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window;
  const [permission, setPermission] = useState(supported ? Notification.permission : "unsupported");

  const subscribe = useCallback(async () => {
    if (!supported) return;
    const perm = await Notification.requestPermission();
    setPermission(perm);
    if (perm !== "granted") return;
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
    });
    const raw = subscription.toJSON();
    await apiClient.post("/customer/push/subscribe", {
      endpoint: raw.endpoint, p256dh: raw.keys.p256dh, auth: raw.keys.auth,
    });
  }, [supported]);

  return { supported, permission, subscribe };
}
